import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Drawer, Form, type FormInstance } from 'antd';
import { useTransportMileageFiltersStore } from 'shared/stores/use-transport-mileage-filters.ts';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters.ts';
import { CarrierMultiSelectFilter } from 'components/common/carrier-multi-select-filter/carrier-multi-select-filter.tsx';

interface ITransportMileageFiltersDrawerProps {
  form: FormInstance;
  isOpen: boolean;
  onClose: () => void;
  showClearFiltersButton: boolean;
}

export const TransportMileageFiltersDrawer: React.FC<ITransportMileageFiltersDrawerProps> = ({
  isOpen,
  onClose,
  form,
  showClearFiltersButton,
}) => {
  const { t } = useTranslation();
  const { filters, setFilters } = useTransportMileageFiltersStore();

  const handleClearFilters = () => {
    setFilters({ date: filters?.date });
    setTimeout(() => form.resetFields(), 0);
    onClose();
  };

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  const clearButton = showClearFiltersButton ? (
    <Button type='link' size='small' onClick={handleClearFilters}>
      {t('common:clear_filters')}
    </Button>
  ) : null;

  return (
    <Drawer placement='right' open={isOpen} extra={[clearButton]} onClose={onClose}>
      <Form form={form} name='transport-mileage-filter' layout='horizontal' initialValues={filters}>
        <CarrierMultiSelectFilter form={form} name='subcontractor' onSetValue={handleSuccess} />
      </Form>
    </Drawer>
  );
};
